import '~/sass/pages/location.scss';
import LocationViewer from '@/components/module/LocationViewer';

const { $ } = window;

$(document).ready(() => {
  let locationType = $('input[name=locationType]:checked').val();// 'showroom';
  let locationViewer;

  function showWithLocationType() {
    $('[data-display-location-type]').hide();

    $(`[data-display-location-type="${locationType}"]`).show();
  }

  $('input[name="locationType"]').on('change', (event) => {
    const { target } = event;
    const typeCode = $(target).filter(':checked').val();

    locationType = typeCode;
    locationViewer.locationType = locationType;
    locationViewer.loadList(false);
    showWithLocationType();
  });

  locationViewer = new LocationViewer(locationType, $('.main-wrapper'), {
    isMaxnervaLog: false,
    isScrollListByMarker: true,
  });

  $('#searchLocationForm').on('submit', (e) => {
    e.preventDefault();
  });
});
